/* eslint-disable no-barrel-files/no-barrel-files */
import type { FC } from 'react'
import React, { lazy, Suspense } from 'react'
import type { PlotParams } from 'react-plotly.js'

// Defer the hefty Plotly runtime until a chart actually renders.
const ForecastPlotly = lazy(() => import('./ForecastPlotly'))

const RawPlot: FC<PlotParams> = (props) => {
  return React.createElement(
    Suspense,
    { fallback: null },
    React.createElement(ForecastPlotly, props)
  )
}

const Plot = React.memo(RawPlot)

export default Plot
export type { Layout, PlotlyHTMLElement } from './ForecastPlotly'
